import { ActionIcon, TextInput, TextInputProps, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { ReactElement } from 'react';

interface SearchInputBaseProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}

export type SearchInputProps = Omit<TextInputProps, 'value' | 'onChange'> & SearchInputBaseProps;

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search',
  style,
  ...textInputProps
}: SearchInputProps): ReactElement {
  const handleClear = () => {
    onChange('');
  };

  return (
    <TextInput
      {...textInputProps}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      style={{
        minWidth: '300px',
        ...style,
      }}
      rightSection={
        value ? (
          <Tooltip label="Clear search">
            <ActionIcon variant="subtle" color="gray" onClick={handleClear} aria-label="Clear search">
              <IconX size={16} />
            </ActionIcon>
          </Tooltip>
        ) : null
      }
    />
  );
}
